const ifCondition = (condition: boolean, then: any, otherwise: any): any => (condition
  ? then : otherwise);

export default ifCondition;
